import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const office = require("../images/office.jpg");

export const Contact = () => {
  return (
    <Container fluid className="content">
      <Row>
        <Col className="title">
          <h1>Contact Us</h1>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={6} lg={4} className="image-column">
          <img src={office} alt="Dr. Madsen's Office" />
          <h2>
            Erik Madsen
            <br />
            D.D.S., M.S.
          </h2>
          10315 South 1300 East
          <br />
          Sandy, UT 84094
          <br />
          <strong>Phone:</strong> <a href="tel:801-943-2700">(801)943-2700</a>
          <br />
          <strong>E-mail:</strong>{" "}
          <a href="mailto:reception@brightersmilesbraces.com?subject=Web%20Inquiry">
            reception@brightersmilesbraces.com
          </a>
          <br />
          <strong>Fax:</strong> (801)495-2771
          <br />
          <br />
        </Col>
        <Col sm={12} md={4} lg={6}>
          <iframe
            title="Map Directions"
            src="https://www.google.com/maps/d/embed?mid=1U_guvN0DPg4LHAXH9z--IcGP7-Q"
            width="100%"
            height="400px"
          />
          <small>
            View{" "}
            <a href="http://maps.google.com/maps/ms?msa=0&amp;msid=210727310675261825304.0004b46520efae8e993cc&amp;ie=UTF8&amp;t=m&amp;vpsrc=6&amp;ll=40.565981,-111.852794&amp;spn=0.01141,0.018239&amp;z=15&amp;source=embed">
              Erik Madsen, D.D.S., M.S.
            </a>{" "}
            in a larger map
          </small>
          <br />
        </Col>
      </Row>
      <Row>
        <Col>
          <br />
          <br />
        </Col>
      </Row>
    </Container>
  );
};
